import { ComponentPropsWithoutRef } from 'react'

import FormSection from '../sections/FormSection'
import FormTabsSection from '../sections/FormTabsSection'
import RichText from '../components/RichText'

import { FormSectionFragment } from '../graphql/formSectionFragment'
import { resolveLinkWithText } from '../graphql/linkWithTextFragment.utils'
import { usePageContext } from '../utils/PageContext'

interface Props {
  content: FormSectionFragment
}

const FormSectionBlock = ({ content: { details } }: Props) => {
  const { siteConfig } = usePageContext()
  if (!details) return null
  const {
    formFields,
    formTabs,
    name,
    privacyPolicy,
    recaptcha,
    error,
    success,
    submitText,
    nextText,
    previousText,
    text,
    formId,
  } = details

  return formTabs.length > 0 ? (
    <FormTabsSection
      formId={formId}
      formTabs={
        formTabs as ComponentPropsWithoutRef<typeof FormTabsSection>['formTabs']
      }
      error={{
        text: error[0]?.text || undefined,
        title: error[0]?.title || undefined,
        buttonText: error[0]?.tryAgainText ?? 'Try again',
      }}
      privacyPolicy={<RichText text={privacyPolicy} />}
      recaptcha={<RichText text={recaptcha} />}
      submitText={submitText}
      nextText={nextText}
      previousText={previousText}
      success={{
        text: success[0]?.text || undefined,
        title: success[0]?.title || undefined,
        link: success[0].link[0]
          ? {
              ...resolveLinkWithText(siteConfig, success[0].link[0]),
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              text: success[0].link[0].text!,
            }
          : { href: '/' },
      }}
    />
  ) : (
    <FormSection
      formId={formId}
      formFields={formFields}
      name={name}
      privacyPolicy={<RichText text={privacyPolicy} />}
      recaptcha={<RichText text={recaptcha} />}
      error={{
        text: error[0]?.text || undefined,
        title: error[0]?.title || undefined,
        buttonText: error[0]?.tryAgainText ?? 'Try again',
      }}
      success={{
        text: success[0]?.text || undefined,
        title: success[0]?.title || undefined,
        link: success[0].link[0]
          ? {
              ...resolveLinkWithText(siteConfig, success[0].link[0]),
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              text: success[0].link[0].text!,
            }
          : { href: '/' },
      }}
      submitText={submitText}
      text={<RichText text={text} />}
    />
  )
}

export default FormSectionBlock
